import React, { useCallback, useLayoutEffect, useState } from 'react';
import Button from 'design-system/Button';
import EmptyComponent from 'design-system/EmptyComponent';
import { AppView, SettingsItemWithCheckBox, SettingsSection, StatusBar, } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import useColors from 'hooks/useColors';
import { useSetupStepLabel } from 'features/onboarding-report/hooks/useSetupStepLabel';
import { isWeb } from '../../../constants';
const strings = {
    default: 'If the date doesn’t fall on a working day, when do you want the period to reset?',
    previousFriday: 'If the previous Friday doesn’t fall on a working day, when do you want the period to reset?',
};
const HolidaySelectionScreen = ({ navigation, route, }) => {
    const colors = useColors();
    const setupStepLabel = useSetupStepLabel(2);
    const { period, onSavePeriod, flow } = route.params;
    const [selected, setSelected] = useState('BEFORE');
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Holiday',
            headerTitle: EmptyComponent,
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const savePeriod = useCallback(() => {
        onSavePeriod({ ...period, onHoliday: selected });
    }, [onSavePeriod, period, selected]);
    return (<AppView avoidHeader isInTab={isWeb}>
      <StatusBar barStyle="dark-content" animated/>
      <ScreenInfoHeader preTitle={flow === 'Onboarding' ? setupStepLabel : undefined} title="Adjust for holidays" subTitle={period.weekday === 5 && period.days?.length === 7
            ? strings.previousFriday
            : strings.default}/>
      <SettingsSection noMarginTop>
        <SettingsItemWithCheckBox title="Before" selected={selected === 'BEFORE'} onPress={() => setSelected('BEFORE')}/>
        <SettingsItemWithCheckBox title="After" selected={selected === 'AFTER'} onPress={() => setSelected('AFTER')}/>
        <SettingsItemWithCheckBox title="No difference" selected={selected === 'SAME'} onPress={() => setSelected('SAME')}/>
      </SettingsSection>
      <Button brand floating title="Continue" onPress={savePeriod}/>
    </AppView>);
};
export default HolidaySelectionScreen;
